import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const benefits = [
  { title: "Greater convenience and control", icon: "Smartphone" },
  { title: "Improved home security", icon: "Shield" },
  { title: "Enhanced energy efficiency", icon: "Zap" },
  { title: "Increased property value", icon: "TrendingUp" },
  { title: "Personalized living environments", icon: "Heart" }
];

const SmartHomeBenefits = () => {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-8">Benefits of Smart Home Technology</h2>
            <h3 className="text-4xl md:text-5xl font-bold text-[#4D4C4A] leading-tight mb-8 italic tracking-tighter">
              A Modern <span className="text-[#91756A]">Lifestyle</span> Advantage.
            </h3>
            <p className="text-slate-500 text-lg leading-relaxed mb-12">
              Implementing smart automation systems provides several advantages for modern households, 
              enhancing every aspect of your daily life.
            </p>
            
            <div className="grid gap-4">
              {benefits.map((benefit, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.5 }}
                  className="flex items-center gap-4 group p-4 border border-slate-50 hover:border-[#91756A]/20 hover:bg-slate-50 transition-all duration-300"
                >
                  <div className="w-8 h-8 rounded-full bg-[#91756A]/10 flex items-center justify-center group-hover:bg-[#91756A] transition-colors duration-300">
                    <Icon name={benefit.icon} size={14} className="text-[#91756A] group-hover:text-white" />
                  </div>
                  <span className="text-[#4D4C4A] font-bold italic uppercase tracking-tight text-lg">{benefit.title}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="grid grid-cols-2 gap-4"
          >
            <div className="space-y-4">
              <div className="aspect-[4/5] overflow-hidden relative group">
                <Image 
                  src="/assets/images/Smart-home-page/Smart-Home-1080-2.jpg" 
                  alt="Smart Home Digital" 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="aspect-square overflow-hidden relative group">
                <Image 
                  src="/assets/images/Smart-home-page/Smart-Home-1080-4.jpg" 
                  alt="Smart Home Seamless" 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
            </div>
            <div className="space-y-4 pt-12">
              <div className="aspect-square overflow-hidden relative group">
                <Image 
                  src="/assets/images/Smart-home-page/Smart-Home-1080-5.jpg" 
                  alt="Smart Home Security" 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="aspect-[4/5] overflow-hidden relative group">
                <Image 
                  src="/assets/images/Smart-home-page/Smart-Home-1080.jpg" 
                  alt="Smart Home Intelligence" 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SmartHomeBenefits;